import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
export var NewsTag = styled.div.withConfig({
  displayName: "partials__NewsTag",
  componentId: "sc-8pcvav-0"
})(["display:inline-block;position:relative;padding:1px 5px 2px;border-radius:3px;margin:2px 2px 2px 4px;cursor:pointer;background:", ";", " ", ";color:#fff;text-transform:lowercase;transition:all 0.15 ease;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.accent3M;
}, fontSmoothing, getFont(-2, 'compact'));